/*
 * @Author: zxl 
 * @Date: 2026-01-11 17:11:13 
 * @Last Modified by: zxl
 * @Last Modified time: 2026-02-04 16:45:31
 */
import React, { useState, useEffect, useCallback } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Spin, message } from 'antd';
import Card from './Card';
import ActiveCardDetail from './ActiveCardDetail';
import { getRiskList } from '../../service/report';
import { _session } from '../../utils/storage';
import { RecordType } from './types';
import './index.scss'

function RiskSystem(props: { flowId: string, disabled?: boolean }) {
    const [loading, setLoading] = useState(true);
    const [cardInfos, setCardInfos] = useState([]);
    const [activeCardIndex, setActiveCardIndex] = useState(-1);
    const [activeCardInfo, setActiveCardInfo] = useState<RecordType | null>(null);
    const history = useHistory();

    const queryRiskList = useCallback(async () => {
        const res = await getRiskList({ flowId: props.flowId });
        if (res.errCode === 0) {
            const cardInfos = res.result || [];
            setCardInfos(cardInfos);
            setLoading(false);
            if (activeCardIndex === -1) {
                if (cardInfos.length > 0) {
                    setActiveCardIndex(0)
                    setActiveCardInfo(cardInfos[0])
                }
            } else {
                setActiveCardInfo(cardInfos[activeCardIndex])
            }
        } else {
            message.error(res.errMsg)
        }
    }, [props.flowId, activeCardIndex])

    const onEvent = async (eventName: string, params?: any) => {
        switch (eventName) {
            case 'toFlowDetail':
                history.push(`/workBench/ReportDetail/${params.flowId}`)
                break;
            case 'refreshRiskList':
                queryRiskList();
                break;
            default:
                break;
        }
    }
    const handleCardClick = (index: number, cardInfo: any) => {
        setActiveCardIndex(index)
        setActiveCardInfo(cardInfo)
    }

    useEffect(() => {
        setLoading(true);
        queryRiskList();
    }, [props.flowId]);

    return (
        <React.Fragment>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Spin />
                </div>
            ) : (
                <div className="risk-wrapper">
                    <div className="leftMenu">
                        <div className="cardList">
                            {
                                cardInfos.length !== 0 ?
                                    cardInfos.map((cardInfo, index) => {
                                        return (
                                            <Card
                                                data={cardInfo}
                                                isSelected={activeCardIndex === index}
                                                onClick={() => handleCardClick(index, cardInfo)}
                                                key={index}
                                            />
                                        )
                                    }) : ''
                            }
                        </div>
                    </div>
                    <div className="riskDetailWrapper">
                        {
                                activeCardInfo ? <ActiveCardDetail
                                    activeCardInfo={activeCardInfo as RecordType}
                                    onEvent={onEvent}
                                    flowId={props.flowId}
                                    disabled={props.disabled}
                                    // onCardInfosChangeCb={queryRiskCards}
                                    // relatedFlowId={relatedFlowId}
                                    // setRelatedFlowId={setRelatedFlowId}
                                    // riskInfoAuthorization={riskInfoAuthorization}
                                    // caseRemarkList={caseRemarkList}
                                    // onFinishcaseRemarkCb={queryCaseRemarks}
                                    // currData={currActiveCardDetail}
                                    // setCurrData={setCurrActiveCardDetail}
                                />  : null
                                // <div className="noRisk"><span>本案件未发现风险</span></div>
                        }
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default RiskSystem